import {Routes} from '@angular/router';
import {ContactUsComponent} from './components/pages/contact-us/contact-us.component';
import {ChatPageComponent} from './components/pages/chat-page/chat-page.component';
import {AdminPageComponent} from './components/pages/admin-page/admin-page.component';
import {LoginPageComponent} from './components/pages/login-page/login-page.component';
import {AdminElementPageComponent} from './components/pages/admin-page/admin-element-page/admin-element-page.component';
import {authGuard} from './guards/auth.guard';
import {AboutPageComponent} from './components/pages/about-page/about-page.component';

export const routes: Routes = [
  // Keep existing bookmarks working while the new journey lives at the root.
  {
    path: 'mobile',
    children: [
      {
        path: '**',
        redirectTo: ({url, queryParams}) => {
          const query = new URLSearchParams(queryParams).toString();
          return (
            '/' + url.map((segment) => segment.toString()).join('/') + (query ? '?' + query : '')
          );
        },
      },
    ],
  },
  {path: 'contact-us', component: ContactUsComponent},
  {path: 'about', component: AboutPageComponent},
  {path: 'chat', component: ChatPageComponent},
  {path: 'admin', component: AdminPageComponent, canActivate: [authGuard]},
  {path: 'login', component: LoginPageComponent},
  {path: 'admin/:type/new', component: AdminElementPageComponent, canActivate: [authGuard]},
  {path: 'admin/:type/:id', component: AdminElementPageComponent, canActivate: [authGuard]},
  // Legacy booking pages are retained in source, but no longer exposed.
  {path: 'airport-booking2/:id', redirectTo: 'journey'},
  {path: 'change-airport', redirectTo: 'journey'},
  {path: 'add-airport', redirectTo: 'journey'},
  {path: 'airport/:airport', redirectTo: 'journey'},
  {
    path: '',
    data: {newJourney: true},
    loadChildren: () =>
      import('./components/pages/mobile/mobile.routes').then((m) => m.mobileRoutes),
  },
];
